import { Pipe, PipeTransform } from '@angular/core';

export enum InvoiceStatus {
  Unknown = 0,
  Draft = 1,
  Pending = 2,
  Processing = 3,
  Paid = 4,
  PaymentFailed = 5,
  Voided = 6,
  PROCESSING,
}

@Pipe({
  name: 'invoiceStatus',
  standalone: false,
})
export class InvoiceStatusPipe implements PipeTransform {
  transform(status: InvoiceStatus): string {
    switch (status) {
      case InvoiceStatus.Unknown:
        return 'Unknown';
      case InvoiceStatus.Draft:
        return 'Draft';
      case InvoiceStatus.Pending:
        return 'Pending';
      case InvoiceStatus.Processing:
        return 'Processing';
      case InvoiceStatus.Paid:
        return 'Paid';
      case InvoiceStatus.PaymentFailed:
        return 'Payment Failed';
      case InvoiceStatus.Voided:
        return 'Voided';
      default:
        return 'Unknown';
    }
  }
}
